export default __webpack_public_path__ + "static/media/574.d2279e09.jpg";